import styled from '@emotion/styled'
import { breakpoints, palette, spacing } from 'main/ui'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  padding-top: ${spacing.majorScale(6)}px;
  background-color: ${palette.whiteDove};
`

export const ContentContainer = styled.div`
  width: 90%;
  @media (min-width: ${breakpoints.md}px) {
    width: 480px;
  }
`
